/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, List, ListItem, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { VFieldMoney4Faturamento } from '../../Estoque/entradaEstoque/VFieldMoney4Faturamento';
import { ContasPagarService } from '../../../shared/services/api/Financeiro/ContasPagar';

interface IFormData {
  idpagar: string;
  emissao: Date;
  vencimento: Date;
  vpagar: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  parcela: string;
  idplanoconta: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  idparceiro: string;
}

interface IFormDataParcelas {
  emissao: Date;
  vencimento: Date;
  vpagar: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  parcela: string;
  idplanoconta: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  idparceiro: string;
}

export interface ConfirmationDialogRawProps {
  value: string;
  dados: IFormDataParcelas;
  open: boolean;
  onClose: (value?: string) => void;
}

export const DialogParcelas: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const navigate = useNavigate();
  const [lista, setLista] = useState<IFormData[]>([]);
  const [atualizarLista, setAtualizarLista] = useState<{ idcontaspagar: string; valorparcela: number; }[]>([]);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      onClose('true');
      navigate('/contaspagar');
    }
  };
  useEffect(() => {
    if (props.dados && typeof props.dados === 'object') {
      setLista([]);
   
      if (Number(props.dados?.parcela) > 1) {
        const valorparcela =  props.dados.vcompra ! / Number(props.dados?.parcela);
        
        for (let i = 0; i < Number(props.dados?.parcela); i++) {
          const dataVencimento = new Date(props.dados.vencimento);
          const newMonth = dataVencimento.getMonth() + i;
          dataVencimento.setMonth(newMonth);
          const  ops = (
            { idpagar: uuidv4(), 
              idparceiro: props.dados.idparceiro,
              idplanoconta: props.dados.idplanoconta,
              tipopagamento: props.dados.tipopagamento,
              emissao: props.dados.emissao,
              vencimento: dataVencimento,
              parcela: `${i+1}/${props.dados.parcela}`, 
              numero: props.dados.numero, 
              vparcela: valorparcela,
              vcompra: props.dados.vcompra,
              acrescimo: props.dados.acrescimo,
              vpago: props.dados.vpago,
              desconto: props.dados.desconto,
              vpagar: valorparcela,
              historico: props.dados.historico,
              tipo: props.dados.tipo,
            });
          setLista((oldLista) => [...oldLista, ops]);       
        }
      }
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    const updatedList = lista.map((listItem) => {
      return {
        idpagar: listItem.idpagar,
        idparceiro: listItem.idparceiro,
        idplanoconta: listItem.idplanoconta,
        tipopagamento: listItem.tipopagamento,
        emissao: listItem.emissao,
        vencimento: listItem.vencimento,
        parcela: listItem.parcela,
        numero: listItem.numero,
        vparcela: listItem.vparcela,
        vcompra: listItem.vcompra,
        acrescimo: listItem.acrescimo,
        vpago: listItem.vpago,
        desconto: listItem.desconto, 
        vpagar: listItem.vpagar,
        historico: listItem.historico,
        tipo: listItem.tipo,
      };           
    });
    const soma = updatedList.reduce((acc, listItem) => acc + listItem.vpagar, 0);
    if (soma.toFixed(2) === props.dados.vcompra.toString()){    
      ContasPagarService
        .createparcelas(updatedList)
        .then((result) => {
          if (result instanceof Error){
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          }else{

            setTms('success');
            setMsg('Lançamento Realizado com sucesso!');
            setOpenmsg(true);
          }
        });   
    }else{
      setTms('error');
      setMsg('Valor Total não Confere');
      setOpenmsg(true);
    }
  };
  const handleInputChange = useCallback((id: string, valor: string) => {
    const updatedList = lista.map((listItem) => {
      if (listItem.idpagar === id) {
        const novoObjeto = { idcontaspagar: id, valorparcela: Number(valor) };
        setAtualizarLista(prevLista => [...prevLista, novoObjeto]);
        return {
          ...listItem,
          valorpagar: Number(valor),
          valorparcela: Number(valor),
        };
      } else {
        return listItem;
      }
    });
  
    setLista(updatedList);
  }, [lista]);



  const handleInputChangeDate = useCallback((id: string, valor: Date) => {
    const updatedList = lista.map((listItem) => {
      if (listItem.idpagar === id) {
        return {
          ...listItem,
          vencimento: valor, 
        };
      } else {

        return listItem;
      }
    });
    setLista(updatedList);
  }, [lista]);
  return (
    <Dialog
      sx={{ width: '100%'  }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >

          {msg}
        </Alert>
      </Snackbar>
      <DialogTitle>Lançamento de Parcelas</DialogTitle>
      <DialogContent dividers>
        <List sx={{ pt: 0 }}>
          {lista.map((listItem) => (
            <ListItem disableGutters key={listItem.idpagar}>
              <Grid container direction="column"  >
                <Grid container item direction="row" >
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid container item direction="row" spacing={1} >
                      <Grid item xs={6} sm={3} md={3} lg={3} xl={3.5}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            format='DD/MM/YYYY'
                            //defaultValue={dayjs()}
                            value={dayjs(listItem.vencimento)}
                            label="Vencimento"
                            onChange={(newValue) => {
                              const inputValue = newValue!.toDate();
                              handleInputChangeDate(listItem.idpagar, inputValue);
                            }}
                            slotProps={{
                              textField: {        
                                size:'small',
                              } 
                            }}   
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} lg={3} xl={2.8}>
                        <TextField
                          size='small'
                          value={listItem.numero}
                          label="Nº do Documento"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} lg={3} xl={1.5}>
                        <TextField
                          size='small'
                          value={listItem.parcela}
                          label="Parcela"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3} lg={3} xl={4}>
                        <VFieldMoney4Faturamento
                          size='small'
                          id={listItem.idpagar}
                          valor={handleInputChange}
                          label="Valor"
                          defaultValue={String(listItem.vparcela)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancelar
        </Button>
        <Button onClick={handleOk}>Confirmar</Button>
      </DialogActions>
    </Dialog>
  );
}; 